import { CultureInfo } from '../culture-info.model';
import { CultureInfoCa } from './ca';

/**
 * @ignore
 */
export const CultureInfoCaAD: CultureInfo = {
  name: 'ca-AD',
  displayName: 'català (Andorra)',
  iso3LanguageCode: 'cat',
  iso2LanguageCode: 'ca',
  ietfLanguageTag: 'ca-AD',
  parent: CultureInfoCa
};
